/**
 * Gate 3 — surfaces without a payload.
 *
 * Flags SDUI surfaces that declare no payload type. A surface with no payload
 * schema cannot be rendered safely — the SDUI engine has nothing to validate.
 *
 * @see docs/impl/129-data-model-coverage-audit.html §21
 */
import type { AtlasManifest } from '../types.js';
import type { ValidationIssue } from './index.js';

/** Detect SDUI surfaces that declare no payload type. */
export function surfaceWithoutPayload(manifest: AtlasManifest): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  for (const surface of manifest.surfaces) {
    if (surface.payloadType.trim() !== '') continue;
    issues.push({
      gate: 'surface-without-payload',
      ref: surface.id,
      message: `Surface "${surface.id}" declares no payload type — the SDUI engine has nothing to validate.`,
    });
  }
  return issues;
}
